import React, { useState, useEffect, useRef, useCallback } from 'react'; // Importe useRef
import './VeiculoseciaEstoque.scss';
import api from '../../../config/configApi';
import { Box, Typography, TextField, Button, Select, MenuItem, InputLabel, FormControl, Divider, FormControlLabel, Checkbox, FormGroup, Menu, Pagination, IconButton } from '@mui/material';
import { MdClose, MdFilterList, MdOutlineKeyboardArrowDown, MdSwapVert } from "react-icons/md";
import { NumericFormat } from 'react-number-format';
import VeiculoseciaVehicleCard from '../../../components/Veiculosecia/VeiculoseciaVehicleCard';
import { useLocation, useNavigate } from 'react-router-dom'; // Importe useLocation e useNavigate

function VeiculoseciaEstoque() {
    const location = useLocation();
    const navigate = useNavigate();
    const isInitialMount = useRef(true); // Para controlar o primeiro render para a URL

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [vehicles, setVehicles] = useState([]);
    const [totalVehicles, setTotalVehicles] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // PAGINAÇÃO
    const [currentPage, setCurrentPage] = useState(0); // Páginas baseadas em 0 para o backend (offset)
    const pageSize = 28; // 28 itens por página

    // ESTADOS DAS TABS DE FILTER
    const [activeMobileFilter, setActiveMobileFilter] = useState(false);

    const openMobileFilter = () => {
        setActiveMobileFilter(true);
        document.body.style.overflowY = 'hidden';
    }

    const closeMobileFilter = () => {
        setActiveMobileFilter(false);
        document.body.style.overflowY = '';
    }

    const [activeTabCleanFilter, setActiveTabCleanFilter] = useState(true);
    const [isToggleSubmenuCleanFilter, setIsToggleSubmenuCleanFilter] = useState(true);
    const handleCleanFilter = () => {
        setActiveTabCleanFilter(!activeTabCleanFilter);
        setIsToggleSubmenuCleanFilter(!isToggleSubmenuCleanFilter);
    }

    const [activeTabYear, setActiveTabYear] = useState(true);
    const [isToggleSubmenuYear, setIsToggleSubmenuYear] = useState(true);
    const handleMenuYear = () => {
        setActiveTabYear(!activeTabYear);
        setIsToggleSubmenuYear(!isToggleSubmenuYear);
    }

    const [activeTabPrice, setActiveTabPrice] = useState(true);
    const [isToggleSubmenuPrice, setIsToggleSubmenuPrice] = useState(true);
    const handleMenuPrice = () => {
        setActiveTabPrice(!activeTabPrice);
        setIsToggleSubmenuPrice(!isToggleSubmenuPrice);
    }

    const [activeTabKm, setActiveTabKm] = useState(true);
    const [isToggleSubmenuKm, setIsToggleSubmenuKm] = useState(true);
    const handleMenuKm = () => {
        setActiveTabKm(!activeTabKm);
        setIsToggleSubmenuKm(!isToggleSubmenuKm);
    }

    const [activeTabGear, setActiveTabGear] = useState(false);
    const [isToggleSubmenuGear, setIsToggleSubmenuGear] = useState(false);
    const handleMenuGear = () => {
        setActiveTabGear(!activeTabGear);
        setIsToggleSubmenuGear(!isToggleSubmenuGear);
    }

    const [activeTabColor, setActiveTabColor] = useState(false);
    const [isToggleSubmenuColor, setIsToggleSubmenuColor] = useState(false);
    const handleMenuColor = () => {
        setActiveTabColor(!activeTabColor);
        setIsToggleSubmenuColor(!isToggleSubmenuColor);
    }

    const [activeTabCategorie, setActiveTabCategorie] = useState(false);
    const [isToggleSubmenuCategorie, setIsToggleSubmenuCategorie] = useState(false);
    const handleMenuCategorie = () => {
        setActiveTabCategorie(!activeTabCategorie);
        setIsToggleSubmenuCategorie(!isToggleSubmenuCategorie);
    }

    // ESTADOS E FUNÇÕES PARA O MENU DE ORDENAÇÃO
    const [activeTabOrder, setActiveTabOrder] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const openSortMenu = Boolean(anchorEl);
    const [sortOption, setSortOption] = useState({
        label: 'Mais relevantes',
        orderBy: 'relevancia', // Usaremos 'relevancia' como um tipo de ordenação customizado
        orderDirection: 'desc' // 'desc' para trazer ofertas primeiro, se aplicável
    });

    const handleSortClick = (event) => {
        setActiveTabOrder(true);
        setAnchorEl(event.currentTarget);
    };

    const handleSortMenuItemClick = (option) => {
        setSortOption(option);
        setAnchorEl(null); // Fecha o menu
        setActiveTabOrder(false);
    };

    const handleSortMenuClose = () => {
        setActiveTabOrder(false);
        setAnchorEl(null);
    };

    // Estados para os filtros - Começam todos vazios/nulos
    const [filters, setFilters] = useState({
        brand: '',
        year: ['', ''],
        price: ['', ''],
        mileage: ['', ''],
        transmission: [], // Alterado para array para múltiplas seleções de checkbox
        color: [], // Alterado para array
        category: [], // Alterado para array
    });

    // Estados para dados mestre dos filtros (se vierem de uma API)
    const [brands, setBrands] = useState([]);
    const [categories, setCategories] = useState([]);
    const [colors, setColors] = useState([]); // Adicionado para cores dinâmicas
    const [transmissions, setTransmissions] = useState([]); // Adicionado para câmbios dinâmicos

    // Função para buscar os dados dos veículos e aplicar filtros
    const fetchVehicles = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const queryParams = new URLSearchParams();

            // Adicionar filtros à URLSearchParams apenas se tiverem valores válidos
            if (filters.brand) queryParams.append('marca', filters.brand);
            if (filters.year[0]) queryParams.append('anoMin', filters.year[0]);
            if (filters.year[1]) queryParams.append('anoMax', filters.year[1]);
            if (filters.price[0]) queryParams.append('precoMin', filters.price[0]);
            if (filters.price[1]) queryParams.append('precoMax', filters.price[1]);
            if (filters.mileage[0]) queryParams.append('quilometragemMin', filters.mileage[0]);
            if (filters.mileage[1]) queryParams.append('quilometragemMax', filters.mileage[1]);

            // Para múltiplos valores (checkboxes), adicione cada um separadamente ou como string separada por vírgula
            // Aqui, estou enviando cada valor como um parâmetro de array: e.g., ?cambio=Manual&cambio=Automatico
            filters.transmission.forEach(val => queryParams.append('cambio', val.toUpperCase()));
            filters.color.forEach(val => queryParams.append('cor', val.toUpperCase()));
            filters.category.forEach(val => queryParams.append('categoria', val));

            // Adicionar parâmetros de ordenação (apenas para o backend)
            if (sortOption.orderBy) {
                queryParams.append('orderBy', sortOption.orderBy);
                queryParams.append('orderDirection', sortOption.orderDirection);
            }

            // Parâmetros de paginação
            queryParams.append('page', currentPage); // Usar o estado currentPage
            queryParams.append('pageSize', pageSize); // Usar o pageSize definido
            queryParams.append('status', true);

            const response = await api.get(`/api/anuncios?${queryParams.toString()}`);
            setVehicles(response.data.data);
            setTotalVehicles(response.data.total); // Use totalCount do seu backend
        } catch (err) {
            const errMessage = err.response?.data?.msg || err.message || 'Erro desconhecido ao carregar veículos.';
            setError(errMessage);
        } finally {
            setLoading(false);
        }
    }, [filters, sortOption, currentPage, pageSize, setLoading, setError, setVehicles, setTotalVehicles]);

    useEffect(() => {
        const handleResize = () => {
            const currentWidth = window.innerWidth;
            setWindowWidth(currentWidth);
        }

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, [])

    // Função para buscar dados mestre para os filtros (ex: marcas, categorias)
    useEffect(() => {
        const fetchMasterData = async () => {
            try {
                const [brandsRes, categoriesRes] = await Promise.all([
                    api.get('/api/marcas'),
                    api.get('/api/categorias'),
                ]);
                setBrands(brandsRes.data);
                setCategories(categoriesRes.data);
                setColors(['Azul', 'Amarelo', 'Branco', 'Preto', 'Prata', 'Bordo', 'Cinza', 'Dourado', 'Laranja', 'Marrom', 'Verde', 'Vermelho', 'Vinho', 'Rosa']);
                setTransmissions(['Manual', 'Automático']);
            } catch (err) {                
            }
        };
        fetchMasterData();
    }, []);

    // Effect para sincronizar filtros do estado com a URL e vice-versa
    useEffect(() => {
        if (isInitialMount.current) {
            // No primeiro render, leia a URL e atualize o estado dos filtros
            const params = new URLSearchParams(location.search);
            const initialFilters = {
                brand: params.get('marca') || '',
                year: [params.get('anoMin') || '', params.get('anoMax') || ''],
                price: [params.get('precoMin') || '', params.get('precoMax') || ''],
                mileage: [params.get('quilometragemMin') || '', params.get('quilometragemMax') || ''],
                transmission: params.getAll('cambio') || [],
                color: params.getAll('cor') || [],
                category: params.getAll('categoria') || [],
            };

            const initialOrderBy = params.get('orderBy') || 'oferta';
            const initialOrderDirection = params.get('orderDirection') || 'desc';
            const initialPage = parseInt(params.get('page')) || 0;

            let initialSortLabel = 'Mais relevantes';
            if (initialOrderBy === 'valor' && initialOrderDirection === 'desc') initialSortLabel = 'Maior preço';
            else if (initialOrderBy === 'valor' && initialOrderDirection === 'asc') initialSortLabel = 'Menor preço';
            else if (initialOrderBy === 'ano_fabricacao' && initialOrderDirection === 'desc') initialSortLabel = 'Ano mais novo';
            else if (initialOrderBy === 'km' && initialOrderDirection === 'asc') initialSortLabel = 'Menor km';

            setFilters(initialFilters);
            setSortOption({
                label: initialSortLabel,
                orderBy: initialOrderBy,
                orderDirection: initialOrderDirection
            });
            setCurrentPage(initialPage);

            isInitialMount.current = false;
        } else {
            // Em mudanças subsequentes do filtro (via UI), atualize a URL
            const queryParams = new URLSearchParams();

            if (filters.brand) queryParams.append('marca', filters.brand);
            if (filters.year[0]) queryParams.append('anoMin', filters.year[0]);
            if (filters.year[1]) queryParams.append('anoMax', filters.year[1]);
            if (filters.price[0]) queryParams.append('precoMin', filters.price[0]);
            if (filters.price[1]) queryParams.append('precoMax', filters.price[1]);
            if (filters.mileage[0]) queryParams.append('quilometragemMin', filters.mileage[0]);
            if (filters.mileage[1]) queryParams.append('quilometragemMax', filters.mileage[1]);

            filters.transmission.forEach(val => queryParams.append('cambio', val.toUpperCase()));
            filters.color.forEach(val => queryParams.append('cor', val.toUpperCase()));
            filters.category.forEach(val => queryParams.append('categoria', val));

            queryParams.append('page', currentPage);

            navigate(`?${queryParams.toString()}`, { replace: true });

            fetchVehicles();
        }
    }, [
        filters,
        sortOption,
        currentPage,
        fetchVehicles,
        navigate           
    ]);

    // Função para lidar com a mudança nos inputs de filtro (Select, TextField simples)
    const handleFilterChange = (event) => {
        const { name, value } = event.target;
        setFilters(prevFilters => ({
            ...prevFilters,
            [name]: value
        }));
        setCurrentPage(0);
    };

    // Função para lidar com mudanças nos checkboxes
    const handleCheckboxChange = (event) => {
        const { name, value, checked } = event.target;
        setFilters(prevFilters => {
            const currentValues = prevFilters[name] || [];
            if (checked) {
                return { ...prevFilters, [name]: [...currentValues, value] };
            } else {
                return { ...prevFilters, [name]: currentValues.filter(item => item !== value) };
            }
        });
        setCurrentPage(0);
    };

    const handleKeyPress = (e) => {
        if (!/[0-9]/.test(e.key)) e.preventDefault()
    }

    // Ações para o input NumericFormat de preço
    const handlePriceNumericInputChange = (values, type) => {
        setFilters((prev) => {
            const newPrice = [...prev.price];
            if (type === 'min') {
                newPrice[0] = values.floatValue || '';
            } else {
                newPrice[1] = values.floatValue || '';
            }
            return { ...prev, price: newPrice };
        });
        setCurrentPage(0);
    };

    // Ações para o input NumericFormat de quilometragem
    const handleMileageNumericInputChange = (values, type) => {
        setFilters((prev) => {
            const newMileage = [...prev.mileage];
            if (type === 'min') {
                newMileage[0] = values.floatValue || '';
            } else {
                newMileage[1] = values.floatValue || '';
            }
            return { ...prev, mileage: newMileage };
        });
        setCurrentPage(0);
    };

    // Função para limpar todos os filtros
    const handleClearAllFilters = () => {
        setFilters({
            brand: '',
            year: ['', ''],
            price: ['', ''],
            mileage: ['', ''],
            transmission: [],
            color: [],
            category: [],
        });
        setSortOption({ // Resetar ordenação também
            label: 'Mais relevantes',
            orderBy: 'relevancia',
            orderDirection: 'desc'
        });
        setCurrentPage(0);
    };

    // Contar filtros aplicados para exibição
    const countAppliedFilters = () => {
        let count = 0;
        if (filters.brand) count++;
        if (filters.year[0] || filters.year[1]) count++;
        if (filters.price[0] || filters.price[1]) count++;
        if (filters.mileage[0] || filters.mileage[1]) count++;
        count += filters.transmission.length;
        count += filters.color.length;
        count += filters.category.length;
        return count;
    };

    // Renderizar filtros aplicados para remoção individual
    const renderAppliedFilters = () => {
        const applied = [];
        if (filters.brand && brands.length > 0) {
            const brandName = brands.find(b => b.id === Number(filters.brand))?.nome || `Marca: ${filters.brand}`;
            applied.push(
                <Button key="brand" className='btn__applied' variant="outlined" size="small" onClick={() => setFilters(prev => ({ ...prev, brand: '' }))}>
                    {brandName.toLowerCase()} &times;
                </Button>
            );
        }
        if (filters.year[0] || filters.year[1]) {
            let yearText = '';
            if (filters.year[0] && filters.year[1]) {
                yearText = `${filters.year[0]} - ${filters.year[1]}`;
            } else if (filters.year[0]) {
                yearText = `Ano mínimo ${filters.year[0]}`;
            } else if (filters.year[1]) {
                yearText = `Ano máximo ${filters.year[1]}`;
            }
            applied.push(
                <Button key="year" className='btn__applied' variant="outlined" size="small" onClick={() => setFilters(prev => ({ ...prev, year: ['', ''] }))}>
                    {yearText} &times;
                </Button>
            );
        }
        if (filters.price[0] || filters.price[1]) {
            let priceText = '';
            const formatPrice = (value) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(value);

            if (filters.price[0] && filters.price[1]) {
                priceText = `${formatPrice(filters.price[0])} - ${formatPrice(filters.price[1])}`;
            } else if (filters.price[0]) {
                priceText = `Preço mínimo ${formatPrice(filters.price[0])}`;
            } else if (filters.price[1]) {
                priceText = `Preço máximo ${formatPrice(filters.price[1])}`;
            }
            applied.push(
                <Button key="price" className='btn__applied' variant="outlined" size="small" onClick={() => setFilters(prev => ({ ...prev, price: ['', ''] }))}>
                    {priceText} &times;
                </Button>
            );
        }
        if (filters.mileage[0] || filters.mileage[1]) {
            let mileageText = '';
            const formatMileage = (value) => new Intl.NumberFormat('pt-BR', { style: 'decimal' }).format(value);

            if (filters.mileage[0] && filters.mileage[1]) {
                mileageText = `${formatMileage(filters.mileage[0])} km - ${formatMileage(filters.mileage[1])} km`;
            } else if (filters.mileage[0]) {
                mileageText = `Km mínimo ${formatMileage(filters.mileage[0])} km`;
            } else if (filters.mileage[1]) {
                mileageText = `Km máximo ${formatMileage(filters.mileage[1])} km`;
            }
            applied.push(
                <Button key="mileage" className='btn__applied' variant="outlined" size="small" onClick={() => setFilters(prev => ({ ...prev, mileage: ['', ''] }))}>
                    {mileageText} &times;
                </Button>
            );
        }
        filters.transmission.forEach(val => {
            applied.push(
                <Button key={`trans-${val}`} className='btn__applied' variant="outlined" size="small" onClick={() => handleCheckboxChange({ target: { name: 'transmission', value: val, checked: false } })}>
                    {val.toLowerCase()} &times;
                </Button>
            );
        });
        filters.color.forEach(val => {
            applied.push(
                <Button key={`color-${val}`} className='btn__applied' variant="outlined" size="small" onClick={() => handleCheckboxChange({ target: { name: 'color', value: val, checked: false } })}>
                    {val.toLowerCase()} &times;
                </Button>
            );
        });
        filters.category.forEach(id => {
            const categoryName = categories.find(c => c.id === Number(id))?.nome || `Categoria ID: ${id}`;
            applied.push(
                <Button key={`cat-${id}`} className='btn__applied' variant="outlined" size="small" onClick={() => handleCheckboxChange({ target: { name: 'category', value: id, checked: false } })}>
                    {categoryName.toLowerCase()} &times;
                </Button>
            );
        });

        return applied.length > 0 ? applied : <Typography variant="body2" sx={{ ml: 1, color: '#888' }}>Nenhum filtro aplicado.</Typography>;
    };

    // Handler para mudança de página
    const handlePageChange = (event, value) => {
        setCurrentPage(value - 1); // MUI Pagination é 1-baseada, nosso estado é 0-baseado
    };

    return (
        <div className='veiculosecia__content'>
            <div className='container-fluid stock-page-container mt-4'>
                <div className='row stock-page-content'>
                    <div className={`col-md-3 filter-aside ${activeMobileFilter ? 'active' : ''}`}>
                        <Box
                            className='filterBox'
                            sx={{ p: 2, border: '1px solid #edecf2', borderRadius: 2, background: '#FFF' }}
                        >
                            <ul className='stock__list p-0 m-0'>
                                {countAppliedFilters() > 0 && windowWidth > 992 && (
                                    <>
                                        <li>
                                            {/* Limpar Filtros */}
                                            <Button
                                                disableRipple
                                                className={`w-100 btn__filter ${activeTabCleanFilter && isToggleSubmenuCleanFilter ? 'active' : ''}`}
                                                onClick={() => handleCleanFilter()}
                                            >
                                                Filtros aplicados <div className='filter__counter'>{countAppliedFilters()}</div>
                                                <span className='arrow'><MdOutlineKeyboardArrowDown /></span>
                                            </Button>
                                            <div
                                                className={`submenuWrapper ${activeTabCleanFilter && isToggleSubmenuCleanFilter ? 'colapse' : 'colapsed'}`}
                                            >
                                                <h6
                                                    className='clean__filter'
                                                    onClick={handleClearAllFilters}
                                                    style={{ cursor: 'pointer', textDecoration: 'underline' }}
                                                >
                                                    Limpar todos
                                                </h6>

                                                <Box
                                                    className='submenu'
                                                    sx={{ display: 'flex', flexWrap: 'wrap', gap: '8px', justifyContent: 'flex-start' }}
                                                >
                                                    {renderAppliedFilters()}
                                                </Box>
                                            </div>
                                        </li>
                                        <Divider />
                                    </>
                                )}
                                {windowWidth < 992 ? (
                                    <div className='d-flex align-items-center justify-content-between mt-2 mb-2'>
                                        <Typography variant='h5' gutterBottom
                                            sx={{ fontSize: '16px', fontWeight: 600, color: '#292929 !important', mt: '10px', mb: '10px' }}
                                        >
                                            Filtrar Veículos
                                        </Typography>
                                        <IconButton
                                            className='btn__close'
                                            onClick={closeMobileFilter}
                                        >
                                            <MdClose />
                                        </IconButton>
                                    </div>
                                ) : (
                                    <Typography variant='h5' gutterBottom
                                        sx={{ fontSize: '16px', fontWeight: 500, color: '#292929 !important', mt: '10px', mb: '10px' }}
                                    >
                                        Filtrar Veículos
                                    </Typography>
                                )}
                                <Divider />
                                <li>
                                    {/* Filtro de Marca */}
                                    <FormControl
                                        className='formcontrol'
                                        size='small'
                                        fullWidth
                                        sx={{ mt: 2, mb: 2 }}
                                    >
                                        <InputLabel id='brand-label'>Marca</InputLabel>
                                        <Select
                                            labelId='brand-label'
                                            id='brand'
                                            name='brand'
                                            value={filters.brand}
                                            label='Marca'
                                            onChange={handleFilterChange}
                                        >
                                            <MenuItem value=''><em>Todas</em></MenuItem>
                                            {brands.map((brand) => (
                                                <MenuItem key={brand.id} value={brand.id}>{brand.nome}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </li>
                                <Divider />
                                <li>
                                    {/* Filtro de Ano */}
                                    <Button
                                        disableRipple
                                        className={`w-100 btn__filter ${activeTabYear && isToggleSubmenuYear ? 'active' : ''}`}
                                        onClick={() => handleMenuYear()}
                                    >
                                        Ano
                                        <span className='arrow'><MdOutlineKeyboardArrowDown /></span>
                                    </Button>
                                    <div
                                        className={`submenuWrapper ${activeTabYear && isToggleSubmenuYear ? 'colapse' : 'colapsed'}`}
                                    >
                                        <p>Escolha um intervalo</p>
                                        <Box
                                            className='submenu'
                                            sx={{ display: 'flex', justifyContent: 'space-between' }}
                                        >
                                            <TextField
                                                className='filter__field'
                                                size='small'
                                                label='Ano mínimo'
                                                variant='outlined'
                                                inputProps={{ maxLength: 4, inputMode: 'numeric' }}
                                                onKeyPress={handleKeyPress}
                                                value={filters.year[0]}
                                                onChange={(e) => setFilters(prev => ({ ...prev, year: [e.target.value, prev.year[1]] }))}
                                                sx={{ width: '48%' }}
                                            />
                                            <TextField
                                                className='filter__field'
                                                size='small'
                                                label='Ano máximo'
                                                variant='outlined'
                                                inputProps={{ maxLength: 4, inputMode: 'numeric' }}
                                                onKeyPress={handleKeyPress}
                                                value={filters.year[1]}
                                                onChange={(e) => setFilters(prev => ({ ...prev, year: [prev.year[0], e.target.value] }))}
                                                sx={{ width: '48%' }}
                                            />
                                        </Box>
                                    </div>
                                </li>
                                <Divider />
                                <li>
                                    {/* Filtro de Valor (Preço) */}
                                    <Button
                                        disableRipple
                                        className={`w-100 btn__filter ${activeTabPrice && isToggleSubmenuPrice ? 'active' : ''}`}
                                        onClick={() => handleMenuPrice()}
                                    >
                                        Preço
                                        <span className='arrow'><MdOutlineKeyboardArrowDown /></span>
                                    </Button>
                                    <div
                                        className={`submenuWrapper ${activeTabPrice && isToggleSubmenuPrice ? 'colapse' : 'colapsed'}`}
                                    >
                                        <p>Escolha um intervalo</p>
                                        <Box
                                            className='submenu'
                                            sx={{ display: 'flex', justifyContent: 'space-between' }}
                                        >
                                            <NumericFormat
                                                className='filter__field'
                                                size='small'
                                                label='Preço mínimo'
                                                variant='outlined'
                                                customInput={TextField}
                                                thousandSeparator
                                                prefix='R$ '
                                                value={filters.price[0]}
                                                onValueChange={(values) => handlePriceNumericInputChange(values, 'min')}
                                                sx={{ width: '48%' }}
                                            />
                                            <NumericFormat
                                                className='filter__field'
                                                size='small'
                                                label='Preço máximo'
                                                variant='outlined'
                                                customInput={TextField}
                                                thousandSeparator
                                                prefix='R$ '
                                                value={filters.price[1]}
                                                onValueChange={(values) => handlePriceNumericInputChange(values, 'max')}
                                                sx={{ width: '48%' }}
                                            />
                                        </Box>
                                    </div>
                                </li>
                                <Divider />
                                <li>
                                    {/* Filtro de Quilometragem */}
                                    <Button
                                        disableRipple
                                        className={`w-100 btn__filter ${activeTabKm && isToggleSubmenuKm ? 'active' : ''}`}
                                        onClick={() => handleMenuKm()}
                                    >
                                        Quilometragem
                                        <span className='arrow'><MdOutlineKeyboardArrowDown /></span>
                                    </Button>
                                    <div
                                        className={`submenuWrapper ${activeTabKm && isToggleSubmenuKm ? 'colapse' : 'colapsed'}`}
                                    >
                                        <p>Escolha um intervalo</p>
                                        <Box
                                            className='submenu'
                                            sx={{ display: 'flex', justifyContent: 'space-between' }}
                                        >
                                            <NumericFormat
                                                className='filter__field'
                                                size='small'
                                                label='Km mínimo'
                                                variant='outlined'
                                                customInput={TextField}
                                                thousandSeparator
                                                suffix=' Km'
                                                value={filters.mileage[0]}
                                                onValueChange={(values) => handleMileageNumericInputChange(values, 'min')}
                                                sx={{ width: '48%' }}
                                            />
                                            <NumericFormat
                                                className='filter__field'
                                                size='small'
                                                label='Km máximo'
                                                variant='outlined'
                                                customInput={TextField}
                                                thousandSeparator
                                                suffix=' Km'
                                                value={filters.mileage[1]}
                                                onValueChange={(values) => handleMileageNumericInputChange(values, 'max')}
                                                sx={{ width: '48%' }}
                                            />
                                        </Box>
                                    </div>
                                </li>
                                <Divider />
                                <li>
                                    {/* Filtro de Câmbio */}
                                    <Button
                                        disableRipple
                                        className={`w-100 btn__filter ${activeTabGear && isToggleSubmenuGear ? 'active' : ''}`}
                                        onClick={() => handleMenuGear()}
                                    >
                                        Câmbio
                                        <span className='arrow'><MdOutlineKeyboardArrowDown /></span>
                                    </Button>
                                    <div
                                        className={`submenuWrapper ${activeTabGear && isToggleSubmenuGear ? 'colapse' : 'colapsed'}`}
                                    >
                                        <FormGroup
                                            className='submenu'
                                        >
                                            {transmissions.map(option => (
                                                <FormControlLabel
                                                    key={option}
                                                    control={
                                                        <Checkbox
                                                            size='small'
                                                            name='transmission'
                                                            value={option.toUpperCase()}
                                                            checked={filters.transmission.includes(option.toUpperCase())}
                                                            onChange={handleCheckboxChange}
                                                        />
                                                    }
                                                    label={option}
                                                />
                                            ))}
                                        </FormGroup>
                                    </div>
                                </li>
                                <Divider />
                                <li>
                                    {/* Filtro de Cor */}
                                    <Button
                                        disableRipple
                                        className={`w-100 btn__filter ${activeTabColor && isToggleSubmenuColor ? 'active' : ''}`}
                                        onClick={() => handleMenuColor()}
                                    >
                                        Cor
                                        <span className='arrow'><MdOutlineKeyboardArrowDown /></span>
                                    </Button>
                                    <div
                                        className={`submenuWrapper ${activeTabColor && isToggleSubmenuColor ? 'colapse' : 'colapsed'}`}
                                    >
                                        <FormGroup
                                            className='submenu'
                                        >
                                            {colors.map(option => (
                                                <FormControlLabel
                                                    key={option}
                                                    control={
                                                        <Checkbox
                                                            size='small'
                                                            name='color'
                                                            value={option.toUpperCase()}
                                                            checked={filters.color.includes(option.toUpperCase())}
                                                            onChange={handleCheckboxChange}
                                                        />
                                                    }
                                                    label={option}
                                                />
                                            ))}
                                        </FormGroup>
                                    </div>
                                </li>
                                <Divider />
                                <li>
                                    {/* Filtro de Categoria */}
                                    <Button
                                        disableRipple
                                        className={`w-100 btn__filter ${activeTabCategorie && isToggleSubmenuCategorie ? 'active' : ''}`}
                                        onClick={() => handleMenuCategorie()}
                                    >
                                        Categoria
                                        <span className='arrow'><MdOutlineKeyboardArrowDown /></span>
                                    </Button>
                                    <div
                                        className={`submenuWrapper ${activeTabCategorie && isToggleSubmenuCategorie ? 'colapse' : 'colapsed'}`}
                                    >
                                        <FormGroup
                                            className='submenu'
                                        >
                                            {categories.map((category) => (
                                                <FormControlLabel
                                                    key={category.id}
                                                    control={
                                                        <Checkbox
                                                            size='small'
                                                            name='category'
                                                            value={category.id}
                                                            checked={filters.category.includes(category.id.toString())}
                                                            onChange={handleCheckboxChange}
                                                        />
                                                    }
                                                    label={category.nome.toLowerCase()}
                                                />
                                            ))}
                                        </FormGroup>
                                    </div>
                                </li>
                            </ul>
                        </Box>
                    </div>

                    {/* Área de Exibição de Veículos (Lado Direito) */}
                    <div className='col-md-9'>
                        {windowWidth < 992 && (
                            <Box
                                className='stockFilterWrapper'
                                sx={{ display: 'flex', gap: '8px', justifyContent: 'flex-start', mb: 2, overflowX: 'scroll', overflowY: 'hidden', whiteSpace: 'nowrap !important' }}
                            >
                                <Button
                                    className='btn__filter-mobile'
                                    endIcon={<MdFilterList />}
                                    onClick={openMobileFilter}
                                >
                                    Filtros
                                </Button>
                                {countAppliedFilters() > 0 ? (
                                    <>
                                        {renderAppliedFilters()}
                                    </>
                                ) : (
                                    <>
                                        <Button
                                            className='btn__applied'
                                            variant='outlined'
                                            endIcon={<MdOutlineKeyboardArrowDown />}
                                            onClick={openMobileFilter}
                                        >
                                            Marca
                                        </Button>
                                        <Button
                                            className='btn__applied'
                                            variant='outlined'
                                            endIcon={<MdOutlineKeyboardArrowDown />}
                                            onClick={openMobileFilter}
                                        >
                                            Ano
                                        </Button>
                                        <Button
                                            className='btn__applied'
                                            variant='outlined'
                                            endIcon={<MdOutlineKeyboardArrowDown />}
                                            onClick={openMobileFilter}
                                        >
                                            Preço
                                        </Button>
                                        <Button
                                            className='btn__applied'
                                            variant='outlined'
                                            endIcon={<MdOutlineKeyboardArrowDown />}
                                            onClick={openMobileFilter}
                                        >
                                            Quilometragem
                                        </Button>
                                        <Button
                                            className='btn__applied'
                                            variant='outlined'
                                            endIcon={<MdOutlineKeyboardArrowDown />}
                                            onClick={openMobileFilter}
                                        >
                                            Câmbio
                                        </Button>
                                        <Button
                                            className='btn__applied'
                                            variant='outlined'
                                            endIcon={<MdOutlineKeyboardArrowDown />}
                                            onClick={openMobileFilter}
                                        >
                                            Cor
                                        </Button>
                                        <Button
                                            className='btn__applied'
                                            variant='outlined'
                                            endIcon={<MdOutlineKeyboardArrowDown />}
                                            onClick={openMobileFilter}
                                        >
                                            Categoria
                                        </Button>
                                    </>
                                )}
                            </Box>
                        )}
                        <div className='d-flex align-items-center justify-content-between mb-1'>
                            <p className='m-0' style={{ fontSize: '14px' }}>{totalVehicles} anúncios encontrados</p>
                            <div className='d-flex align-items-center'>
                                {windowWidth > 992 && (
                                    <>
                                        <MdSwapVert />
                                        <span>
                                            <p className='m-0 me-1' style={{ fontSize: '14px' }}>Ordenar Por:</p>
                                        </span>
                                    </>
                                )}
                                <Button
                                    onClick={handleSortClick}
                                    className={`btn__order ${activeTabOrder ? 'active' : ''}`}
                                >
                                    {sortOption.label}
                                    <span className='arrow'><MdOutlineKeyboardArrowDown /></span>
                                </Button>
                                <Menu
                                    id="sort-menu"
                                    anchorEl={anchorEl}
                                    open={openSortMenu}
                                    onClose={handleSortMenuClose}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'center'
                                    }}
                                    transformOrigin={{ horizontal: 'center' }}
                                >
                                    <MenuItem onClick={() => handleSortMenuItemClick({ label: 'Mais relevantes', orderBy: 'oferta', orderDirection: 'desc' })} sx={{ fontSize: '14px' }}>Mais relevantes</MenuItem>
                                    <MenuItem onClick={() => handleSortMenuItemClick({ label: 'Maior preço', orderBy: 'valor', orderDirection: 'desc' })} sx={{ fontSize: '14px' }}>Maior preço</MenuItem>
                                    <MenuItem onClick={() => handleSortMenuItemClick({ label: 'Menor preço', orderBy: 'valor', orderDirection: 'asc' })} sx={{ fontSize: '14px' }}>Menor preço</MenuItem>
                                    <MenuItem onClick={() => handleSortMenuItemClick({ label: 'Ano mais novo', orderBy: 'ano_fabricacao', orderDirection: 'desc' })} sx={{ fontSize: '14px' }}>Ano mais novo</MenuItem>
                                    <MenuItem onClick={() => handleSortMenuItemClick({ label: 'Menor km', orderBy: 'km', orderDirection: 'asc' })} sx={{ fontSize: '14px' }}>Menor km</MenuItem>
                                </Menu>
                            </div>
                        </div>
                        <div className='row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-4'>
                            {loading ? (
                                <div className='col text-center w-100'>
                                    <Typography variant='h6'>Carregando veículos...</Typography>
                                </div>
                            ) : error ? (
                                <div className='col text-center w-100'>
                                    <Typography variant='h6' color='error'>{error}</Typography>
                                </div>
                            ) : vehicles.length === 0 ? (
                                <div className='col text-center w-100'>
                                    <Typography variant='h6'>Nenhum veículo encontrado com os filtros aplicados.</Typography>
                                </div>
                            ) : (
                                vehicles.map(vehicle => (
                                    <div
                                        className='col'
                                        key={vehicle.id}
                                    >
                                        <VeiculoseciaVehicleCard vehicle={vehicle} />
                                    </div>
                                ))
                            )}
                        </div>
                        {/* Componente de Paginação */}
                        {totalVehicles > 0 && (
                            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3, mb: 3 }}>
                                <Pagination
                                    count={Math.ceil(totalVehicles / pageSize)}
                                    page={currentPage + 1} // MUI Pagination é 1-baseada
                                    onChange={handlePageChange}
                                    variant='outlined'
                                    shape='rounded'
                                    onClick={() => window.scroll(0, 0)}
                                />
                            </Box>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default VeiculoseciaEstoque;